const AUTH_URL = `${process.env.PUBLIC_URL || ''}/api/auth.php`;

async function authRequest(payload) {
  try {
    const res = await fetch(AUTH_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    return {
      data: json.data ?? null,
      error: json.error ?? (!res.ok ? { message: `HTTP ${res.status}` } : null),
    };
  } catch (err) {
    return { data: null, error: { message: err.message || 'Network error' } };
  }
}

export const authApi = {
  register(payload) {
    return authRequest({ action: 'register', ...payload });
  },
  login(email, password, { requireAdmin = false } = {}) {
    return authRequest({ action: 'login', email, password, requireAdmin });
  },
  setPassword(id, password) {
    return authRequest({ action: 'setPassword', id, password });
  },
  approve(id, approvedBy = null) {
    return authRequest({ action: 'approve', id, approved_by: approvedBy });
  },
  reject(id) {
    return authRequest({ action: 'reject', id });
  },
};

export default authApi;
